import { Button, Menu } from "antd";

export const editButtonMenu = ({
  handleOpenForm,
}: {
  handleOpenForm: (initTitle: string, workType: string) => void;
}) => {
  return (
    <Menu
      className="add-record-button"
      items={[
        {
          key: "1",
          label: (
            <Button
              type="primary"
              onClick={() => {
                handleOpenForm("Добавление записи о работе в раздел 3 ОЖР", "WORK");
              }}
              className="cl"
            >
              Работа
            </Button>
          ),
        },
        {
          key: "2",
          label: (
            <Button
              type="primary"
              onClick={() => {
                handleOpenForm("Добавление записи об испытании в раздел 3 ОЖР", "TEST");
              }}
              className="cl"
            >
              Испытание
            </Button>
          ),
        },
      ]}
    />
  );
};

